import { Box, styled, TextField, Typography, useTheme } from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import React, { useState } from "react";
import { User } from "@domain/entities/Users";
import { useTranslation } from "react-i18next";
import { InputAutocomplete } from "@presentation/components/inputs/atoms/InputAutocomplete";

const StyledTextField = styled(TextField)(() => ({
  ".MuiOutlinedInput-root": {
    height: "32px",
    borderRadius: "8px",
    paddingTop: 0,
    paddingBottom: 0,
  },
}));

const TotalSearchBar = (props: any): React.JSX.Element => {
  const theme = useTheme();
  const { error, options, label } = props;
  const [open, setOpen] = useState(false);
  const loading = open && options.length === 0;

  const { t } = useTranslation();

  return (
    <Box>
      <Typography variant="body2" sx={{ mb: 1 }}>
        {label}
      </Typography>
      <InputAutocomplete
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        getOptionLabel={(option: User) =>
          option?.profile
            ? t("common.full_name", { firstName: option.profile?.firstName, lastName: option.profile?.lastName }).trim()
            : ""
        }
        isOptionEqualToValue={(option: User, value: User) => option.id === value.id}
        popupIcon={<SearchRoundedIcon />}
        loading={loading}
        clearOnBlur={true}
        sx={{
          ...(error && { color: theme.palette.secondary.main }),
          padding: 0,
        }}
        renderInput={(params: any) => <StyledTextField size="small" {...params} />}
        renderOption={(p, option: User) => {
          return (
            <Box component="li" {...p} key={option.id}>
              {option.profile
                ? t("common.full_name", {
                    firstName: option.profile?.firstName,
                    lastName: option.profile?.lastName,
                  }).trim()
                : ""}
            </Box>
          );
        }}
        {...props}
      />
    </Box>
  );
};

export default TotalSearchBar;
